import React from "react";
import { useSelector } from "react-redux";
import { BrandImage } from "../../components/brandImage";
import { LuArrowLeft, LuBookOpen, LuShoppingBag, LuUsers } from "react-icons/lu";
import "./style.css";
import "./responsive.css";
import "./access.css";

export const AccessLayout = ({ title, eyebrow, intro, children, onBack, pending = false }) => {
  const info = useSelector(state => state.aplicationConfig.corporationData.info);
  const name = info?.corporation?.name || "Tu negocio";
  return <main className="adminLogin">
    <aside className="accessStory" aria-label="Administración del negocio">
      <div className="accessBrand"><BrandImage src={info?.logo} className="accessLogo" /><div><strong>{name}</strong><span>ADMINISTRACIÓN</span></div></div>
      <div className="accessStoryContent"><span className="accessEyebrow">TU ESPACIO DE TRABAJO</span><h2>Todo lo que mueve<br />tu negocio.</h2><p>Tu carta, tus pedidos y tu equipo.<br />Organizados en un mismo lugar.</p>
        <div className="accessFeatures"><div><LuBookOpen aria-hidden="true" /><span>Carta y productos</span></div><div><LuShoppingBag aria-hidden="true" /><span>Gestión de pedidos</span></div><div><LuUsers aria-hidden="true" /><span>Tu equipo</span></div></div>
      </div><span className="accessPowered">delibrán <span>· Administración</span></span>
    </aside>
    <section className="accessMain" aria-labelledby="access-title"><div className="accessCard">
      {onBack && <button className="accessBack" type="button" disabled={pending} onClick={onBack}><LuArrowLeft aria-hidden="true" />Volver a iniciar sesión</button>}
      <div className="accessMerchant"><BrandImage src={info?.logo} className="accessMerchantLogo" /><span>{name}</span></div>
      <span className="accessEyebrow">{eyebrow}</span>
      <h1 id="access-title">{title}</h1>
      <p className="accessIntro">{intro}</p>
      {children}
      <p className="accessFootnote">Panel de administración de {name}</p>
    </div></section>
  </main>;
}
